import { useEffect, useRef } from "react";

export function useMount(effect: () => void) {
    const hasRun = useRef(false)
    useEffect(() => {
        if (!hasRun.current) {
            hasRun.current = true;
            effect();
        }
    }, []);
}
